import { Accordion, Box, Separator, Stack, Text } from "@chakra-ui/react";
import PricingFooter from "@/components/pricingFooter";
import ConsumerGpuTable from "./consumerGPU";
import EnterpriseGpuPricingTable from "./enterpriseGPU";
import { PRICING_NOTES, GPU_TABLE_FOOTER_CONSTANTS } from "./constants";

export const GpuFooter = () => {
  return (
    <Box w="full">
      <Accordion.Root collapsible mb={8}>
        <Accordion.Item value="pricing-policies" borderRadius="md" border="none">
          <Accordion.ItemTrigger p={4} w="fit-content">
            <Box fontWeight="bold" fontSize="lg" borderRadius="md" color="primary.200">
              *See Pricing Policies and Services
            </Box>
            <Accordion.ItemIndicator />
          </Accordion.ItemTrigger>
          <Accordion.ItemContent pb={4} border="1px solid" borderColor="gray.200">
            <Stack gap={3}>
              {PRICING_NOTES.map((note, index) => (
                <Text fontSize="md" color="gray.600" key={index}>
                  {note}
                </Text>
              ))}
            </Stack>
          </Accordion.ItemContent>
        </Accordion.Item>
      </Accordion.Root>
      <PricingFooter {...GPU_TABLE_FOOTER_CONSTANTS} />
      <Separator borderWidth="2px" borderColor="#ECECEC" my={10} />
    </Box>
  );
};

const GpuTables = () => {
  return (
    <Box>
      <Box mb={16}>
        <EnterpriseGpuPricingTable />
      </Box>
      <ConsumerGpuTable />
      <GpuFooter />
    </Box>
  );
};

export default GpuTables;
